import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

// Company logos as components with external URLs
const CompanyLogos = {
  C3AI: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] rounded">
      <span className="text-black font-bold text-lg">C3 AI</span>
    </div>
  ),
  AWS: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" 
        alt="AWS Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  ),
  PwC: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/0/05/PricewaterhouseCoopers_Logo.svg" 
        alt="PwC Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  ),
  UniMelb: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="https://peopleandparks.org/wp-content/uploads/2024/10/the-university-of-melbourne-logo-svg-vector.svg" 
        alt="University of Melbourne Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  ),
  Slalom: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/a/ae/Slalom_Consulting_Logo.svg" 
        alt="Slalom Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  ),
  Microsoft: () => (
    <div className="w-12 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <svg viewBox="0 0 50 50" className="w-full h-full">
        <rect x="5" y="5" width="19" height="19" fill="#F25022" />
        <rect x="26" y="5" width="19" height="19" fill="#7FBA00" />
        <rect x="5" y="26" width="19" height="19" fill="#00A4EF" />
        <rect x="26" y="26" width="19" height="19" fill="#FFB900" />
      </svg>
    </div>
  ),
  CareGift: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="/images/caregift-logo.png" 
        alt="CareGift Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  ),
  Cerner: () => (
    <div className="w-16 h-12 flex items-center justify-center bg-[#E0E0E0] p-1 rounded">
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/8/8e/Oracle_Cerner_logo.svg" 
        alt="Oracle Cerner Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  )
};

// Experience data
const experienceData = [
  {
    id: 1,
    company: 'C3 AI',
    logo: 'C3AI',
    title: 'Director, Customer Solutions - State and Local Government',
    period: 'Sep 2024 - Present · 7 mos',
    location: 'Redwood City, California, United States',
    description: 'Brad leads AI/ML solution development and implementation for state and local government clients, driving digital transformation through enterprise AI applications. As a trusted advisor, he collaborates with agency leaders and cross-functional teams to scope, design, and deploy AI-powered solutions that enhance operational efficiency, automate workflows, and drive data-driven decision-making. He is recognized for his expertise in AI/ML strategy, executive engagement, and competitive differentiation, ensuring successful adoption and measurable impact.',
    details: []
  },
  {
    id: 2,
    company: 'Amazon Web Services (AWS)',
    logo: 'AWS',
    title: 'Strategic Program Leader',
    period: 'Dec 2019 - Jun 2023 · 3 yrs 7 mos',
    location: 'Yakima, Washington, United States',
    description: 'Brad innovated as Strategic Program Leader and Customer Practice Manager chartering a multi-year migration and modernization program, which focused on powering enhanced clinical experiences, increasing efficiencies by lowering operational burdens, and accelerating cutting-edge innovations thereby advancing better patient health outcomes. Total sales of $3M in 2023; $11.8M in 2022.',
    details: [
      'At Oracle Cerner, executed our $160M Professional Services Agreement, as part of a larger $650M Enterprise Agreement. Authored ~25 SOWs over the last three years, generating $30M in equivalent billable revenue. Led a team of 30 ProServe resources, and overarching remit for 300-400 Partner resources.',
      'At Pfizer, Inc., advanced new strategies and techniques for tracking, progressing, and optimizing business development processes, leading to a new billable pipeline of $5-$7M for 2023. Operated our engagement and delivery teams across three active SOWs by orchestrating stakeholder alignment, building team cohesion, managing delivery, and reporting to executive teams at AWS and customer.',
      'Within AWS, coached internal teams in cloud best practices to accelerate cloud adoption scenarios by leveraging customer use cases with a focus on enabling innovation and growth on the core platforms; Attained $77M in account revenue in 2023, which was a 33% increase year-over-year.'
    ]
  },
  {
    id: 3,
    company: 'PwC Australia',
    logo: 'PwC',
    title: 'Director, Technology Consulting',
    period: 'Mar 2017 - Dec 2019 · 2 yrs 10 mos',
    location: 'Melbourne, Australia',
    description: 'Brad excelled as a Director in PwC\'s Technology Consulting practice specialising in programme and project delivery for state government and healthcare clients; by breaking down silos and aligning business needs, user experiences, and different technology lenses, clients innovated and reinvented their businesses enabling them to be successful in this digital age. Total sales of $8.0M in 2019.',
    details: [
      'Victoria Police – BlueConnect Program: Executed the $242M Mobile Technology and $90M Body Worn Camera projects, managing a team of over 125 staff across seven companies, including 25 PWC employees. Drove the short and long-term vision and strategic plans, objectives, policies, and budgets across seven programmes of work through a successful three-year transformation.',
      'Within PwC, developed new business opportunities, built client relationships, and developed ICT strategy and five-year roadmaps, including current state reviews and gap analyses against market trends.'
    ]
  },
  {
    id: 4,
    company: 'University of Melbourne',
    logo: 'UniMelb',
    title: 'Guest Lecturer',
    period: 'Mar 2017 - Dec 2019 · 2 yrs 10 mos',
    location: 'Melbourne, Australia',
    description: 'Guest lecturer - Master of Information Systems program.',
    details: []
  },
  {
    id: 5,
    company: 'Slalom Consulting',
    logo: 'Slalom',
    title: 'Senior Consultant, Healthcare',
    period: 'Mar 2015 - Feb 2017 · 2 yrs',
    location: 'Greater Seattle Area',
    description: 'Brad led as Program Director of a three-year clinical integration program for Virginia Mason Medical Centre and Yakima Memorial\'s electronic medical records and enterprise master patient identity solution; previously led the ICD-10 remediation and 2015 upgrade efforts.',
    details: [
      'Orchestrated the end-to-end project lifecycle, including gathering business requirements and technical specs, design, prototyping, development, testing, and ongoing maintenance/support. Directed three independent vendor contracts, coordinated activities, and managed escalations. Oversaw all operational and financial aspects, including project plans, resource management, risk assessment and mitigation, and tracking project hours to minimize risk and ensure timely delivery.',
      'Within Slalom, cultivated new business opportunities, fostered client relationships, and prepared proposals and SOWs. Spearheaded internal practice development by authoring monthly internal newsletters covering subject matter expertise, team growth, business opportunities, project spotlights, and industry updates/trends.'
    ]
  },
  {
    id: 6,
    company: 'Microsoft',
    logo: 'Microsoft',
    title: 'Principal Program Manager, Microsoft IT',
    period: 'Feb 2012 - Dec 2014 · 2 yrs 11 mos',
    location: 'Greater Seattle Area',
    description: 'Brad operated as a Senior Program Manager at Microsoft IT, leading business analysis, program management, and project management. Authored business process models, conducted user research, and gathered customer feedback for developing a multi-year technology roadmap. Governed the entire software delivery lifecycle from inception to final delivery and composed comprehensive project management plans, covering scope, schedule, cost, communication, integration, issues, procurement, quality, resources, risk, and stakeholder management.',
    details: [
      'Solely managed project lifecycle technology solutions and services within Microsoft IT, supporting a community of over 4,000 employees and approximately 1,500 Project Managers. Pioneered the evaluation and adoption of O365 technologies, including SharePoint Online and Project Online, through technology adoption programs and A/B testing across seven business process units and over 400 initial participants.',
      'Stewarded the technology ownership transition for Archer to Microsoft IT, overseeing all enterprise governance, risk, and compliance technology solutions, impacting approximately 35,000 active users (including 10,000 monthly users and 3,000 unique users).'
    ]
  },
  {
    id: 7,
    company: 'Microsoft',
    logo: 'Microsoft',
    title: 'Senior Engagement Manager, Health Solutions Group',
    period: 'Jun 2010 - Feb 2012 · 1 yr 9 mos',
    location: 'Greater Seattle Area',
    description: 'Brad led strategic healthcare projects with responsibility for delivering projects on time, on budget, and with high customer satisfaction. Areas of focus included: Health Information Exchanges and Amalga UIS / Web.',
    details: [
      'Served as Health Solutions Group project manager for two Health Information Exchanges and two Healthcare systems. Executed on time, on budget implementations for Metropolitan Chicago Healthcare Council and Health Choice Network, achieving $9.05M and $2.02M in revenue, respectively.',
      'Oversaw all operational and financial aspects of projects including: creating and maintaining project plans, resource management, performing risk assessment and mitigation plans, and tracking forecasted project hours against actual hours, to minimize risk and keep projects on schedule.',
      'Completed five pilot programs focused on methodology improvements, best practices and technical standards, customer readiness, resource management and utilization, and overall project tracking and metrics; allowing the organization to provide higher quality projects while reducing time and cost.'
    ]
  },
  {
    id: 8,
    company: 'CareGift',
    logo: 'CareGift',
    title: 'Co-founder | Product Marketing Manager',
    period: 'Mar 2009 - Jun 2011 · 2 yrs 4 mos',
    location: 'Lenexa, KS',
    description: 'Brad created a consumer-to-consumer platform for people to receive financial donations, stay connected with loved ones, and share their experiences before, during, and after a health event.',
    details: [
      'Co-authored marketing collateral including company overview, business model, competitive analysis, and business opportunities. Also composed key areas of website content including Terms of Use, Privacy Policy, Security Policy, and general content areas.',
      'Operated a 12-month dev and product release cycle, which included: gathering requirements and technical specs, design, prototyping, .com development and coding (outsourced), regression and integration testing, and maintenance/support. Coordinated A/B testing programs with early-stage products and samples on web and mobile. Coordination of PayPal APIs from eCommerce functionality.',
      'Investigated market and performed competitive analysis to create a strategic marketing plan and collateral for a successful product launch in Q2 2010; shelved and discontinued in Q2 2011.'
    ]
  },
  {
    id: 9,
    company: 'Cerner Corporation',
    logo: 'Cerner',
    title: 'Manager, Senior Engagement Manager',
    period: 'Apr 2008 - Jun 2010 · 2 yrs 3 mos',
    location: 'Kansas City, Missouri Area',
    description: 'Brad led strategic healthcare, upgrade projects; as project manager had core responsibility of delivering projects on time, on budget, and with high customer satisfaction. Cultivated and mentored eight Engagement Leaders.',
    details: [
      'Oversaw all operational and financial aspects of 19 upgrade projects in 2009, generating $5.25M in revenue; oversaw all operational and financial aspects of 14 upgrade projects in 2008, generating $4.69M in revenue.',
      'Influenced ongoing sales activities to create engagement proposals and support forecasted revenue; maintained an active pipeline to support 25 project managers.',
      'Demonstrated skills in leadership, strategic thinking and execution, team and relationship building, and change management to cultivate and manage executive relationships at the director and C-suite level.'
    ]
  },
  {
    id: 10,
    company: 'Cerner Corporation',
    logo: 'Cerner',
    title: 'Solution Architect',
    period: 'Sep 2005 - Apr 2008 · 2 yrs 8 mos',
    location: 'London, United Kingdom',
    description: 'Brad was expated to London to work on the National Programme for IT (NPfIT) project with the NHS, Fujitsu, and BT during the first two phases of a four-phase project implementing two Cerner products. Directed approximately 30 Solution Delivery Consultants and mentored three Solution Architects.',
    details: [
      'Documented phase one and two customer event agendas, visit summaries, design and build guides, data collection worksheets, build status worksheets, conversion readiness assessments, and upgrade migration documents.',
      'Partnered with Human Resources and executive leadership to enhance employee retention and educational opportunities, surpassing 600% growth within the organization.',
      'Interim, 6-month assignment as a Sr. Strategist upon returning to the US. Documented vision, scope of capabilities, and risk analysis for approximately 15 features to produce a web-based consumer health record released in December 2007.'
    ]
  },
  {
    id: 11,
    company: 'Cerner Corporation',
    logo: 'Cerner',
    title: 'Senior Product Manager',
    period: 'Dec 2002 - Sep 2005 · 2 yrs 10 mos',
    location: 'Kansas City, Missouri Area',
    description: 'Brad was promoted from Sr. Solution Delivery Consultant to PowerNote Solution Designer for Win32 and Web, then promoted from Solution Designer to Solution Manager across all platforms. Cultivated and mentored four Solution Designers.',
    details: [
      'Collaborated across solution groups on similar functionality to document product vision, functional requirements, and risk analysis for 23 Win32 projects and eight Web projects.',
      'Preserved client relationships by meeting with the client project team to discuss enhancement requests, prioritization, and project planning timeframes.',
      'Organized 11 usability studies that led to product redesign and enhanced the overall user experience and workflow.'
    ]
  },
  {
    id: 12,
    company: 'Cerner Corporation',
    logo: 'Cerner',
    title: 'Senior Solution Delivery Consultant',
    period: 'Jul 2000 - Dec 2002 · 2 yrs 6 mos',
    location: 'Kansas City, Missouri Area',
    description: 'Brad was responsible for the installation of PowerNote (physician documentation) for 37 clients and the primary contact for the client\'s solution-specific training, troubleshooting, and consultation needs.',
    details: [
      'Maintained client relationships by meeting with the project team for initial demos, performed design-consulting sessions, conducted project-planning sessions, and conducted project-readiness assessments prior to conversion.',
      'Produced client materials with information regarding project scope, entire implementation process, a functional walkthrough of the product with visual aids, and a proposed conversion plan.',
      'Trained physicians and super-users and commanded the conversion of PowerNote at 20 client sites, eight of which became reference sites for the Physician Practice Enterprise.'
    ]
  }
];

const ExperienceTimeline = () => {
  const [expandedItems, setExpandedItems] = useState([]);

  const toggleExpand = (id) => {
    if (expandedItems.includes(id)) {
      setExpandedItems(expandedItems.filter(item => item !== id));
    } else {
      setExpandedItems([...expandedItems, id]);
    }
  };

  return (
    <section className="py-16 bg-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-light mb-4">Professional Experience</h2>
          <p className="text-xl text-light/80 max-w-3xl mx-auto">
            Over 25 years of expertise in technology leadership, strategic planning, and digital transformation.
          </p>
        </div>
        <div className="max-w-4xl mx-auto"> {/* Added container with same width as mission statement */}
          <div className="space-y-6">
            {experienceData.map((experience) => {
              const Logo = CompanyLogos[experience.logo];
              const isExpanded = expandedItems.includes(experience.id);

              return (
                <div 
                  key={experience.id}
                  className="border border-light/10 rounded-lg bg-dark/80 backdrop-blur-sm overflow-hidden transition-all duration-300"
                >
                  <div 
                    className="p-4 md:p-6 flex flex-col md:flex-row items-start gap-4 cursor-pointer"
                    onClick={() => toggleExpand(experience.id)}
                  >
                    <div className="flex-shrink-0 mt-1">
                      {Logo && <Logo />}
                    </div>
                    
                    <div className="flex-grow">
                      <div className="flex justify-between items-start">
                        <div>
                          <h3 className="text-xl font-bold text-light">{experience.title}</h3>
                          <p className="text-accent">{experience.company}</p>
                          <p className="text-light/70 text-sm">{experience.period}</p>
                          <p className="text-light/70 text-sm">{experience.location}</p>
                        </div>
                        <button 
                          className="text-accent"
                          aria-label={isExpanded ? "Collapse details" : "Expand details"}
                        >
                          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      </div>
                      
                      <div className="mt-2">
                        <p className="text-light/90">{experience.description}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Expandable content */}
                  {isExpanded && experience.details.length > 0 && (
                    <div className="px-4 md:px-6 pb-6 pt-2 ml-0 md:ml-20 border-t border-light/10">
                      <ul className="space-y-3">
                        {experience.details.map((detail, index) => (
                          <li key={index} className="flex items-start gap-2">
                            <span className="text-accent mt-1.5">•</span>
                            <p className="text-light/80">{detail}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceTimeline;